var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-3"},[_c('v-card-text',{staticClass:"pt-1"},[_c('v-text-field',{attrs:{"label":"Suche","value":_vm.$route.query.suche,"append-outer-icon":"search","hide-details":""},on:{"input":_vm.doSearch}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }